import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Company } from 'app/models/company.model';
import { Envanter } from 'app/models/envanter.model';
import { User } from 'app/models/user.model';
import { CompanyService } from 'app/services/company.service';
import { EnvanterService } from 'app/services/envanter.service';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import { BaseFormComponent } from '../../base-form.component';

@Component({
    selector: 'app-envanter-form',
    templateUrl: './envanter-form.component.html',
    styleUrls: ['./envanter-form.component.scss']
})
export class EnvanterFormComponent extends BaseFormComponent implements OnInit {
    public selectedCompany: number;
    public fileData: File[] = []
    public companyId:number;
    public companyList:Array<Company>=[];

    public envanter: Envanter = {
        status: true,
    }
    constructor(
        private _toasterService: ToasterService,
        private _companyService: CompanyService,
        private _envanterService: EnvanterService,
        private _translateService: TranslateService
    ) {
        super();
    }

    async ngOnInit(): Promise<void> {
        try {
            this.companyId = parseInt(localStorage.getItem("CompanyID"))
            this.companyList =await this._companyService.getCompanies();
            this.selectedCompany=this.envanter.companyId;
        } catch (error) {
            console.warn(error);

        }
    }

    async submit(e) {

        this.envanter.status = true;
        this.envanter.companyId = parseInt(localStorage.getItem("CompanyID")) ? this.selectedCompany : parseInt(localStorage.getItem("CompanyID"))
        if (e.invalid) {
            this._toasterService.toastWarning(
                this._translateService.instant("PLEASE_FILL_IN_THE_FORM_CORRECTLY")
            );
            return;
        }
        if (this.fileData.length != 0) {
            if (this.envanter.icon != '') {
                try {
                    await this._envanterService.ImageDelete(this.envanter)
    
                } catch (error) {
                    console.warn(error);
    
                }
            }
            const formData = new FormData();
            formData.append("files", this.fileData[0])
            try {
                let uresponse = await this._envanterService.upload(formData);
                this.envanter.icon = uresponse.toString()
                await this._envanterService.updated(this.envanter);
                this.updated.emit(true);
    
            } catch (error) {
                console.warn(error);
                this.updated.emit(false);
    
            }
        }
        else{
            try {
                await this._envanterService.updated(this.envanter);
                this.updated.emit(true)
            } catch (error) {
                console.warn(error);
                this.updated.emit(false)
            }
        }
    }


    public fileChange(f) {
        try {
            this.fileData.push(f[0])
        } catch (error) {
            console.warn(error);
        }
    }


}
